import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {END_NODE_ID, exclusiveGatewayType, HEAD_NODE_ID} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import {select, Store} from "@ngrx/store";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {
  selectFloatedNodesByLayer,
  selectFloatedNodesMap
} from "@ispm-client/modules/bpmn-modeler/store/selectors/floating-nodes.selector";
import {filter, map, take} from "rxjs/operators";
import {selectNodeCreationInfoById, selectNodesCreationInfo} from "@ispm-client/modules/bpmn-modeler/store/selectors";
import {TreeNavigator} from "@ispm/shared/bpmn-io/services/tree-navigator";
import {PathwayElementRegistry} from "@ispm/shared/bpmn-io/pathway-element-registry";
import {OverlayType} from "@ispm/shared/bpmn-io/overlay-types";
import ElementRegistry from "diagram-js/lib/core/ElementRegistry";
import {OverlayUtils} from "@ispm-client/modules/bpmn-modeler/bpmn/utils/overlay-utils";


export class OverlaysInterceptor extends CommandInterceptor {


  constructor(private eventBus: EventBus, private overlays, private treeNavigator: TreeNavigator) {
    super(eventBus);
    this.eventBus.on('overlay.added', (event) => {
      const element = event.element;
      if (element && element.businessObject.neighborhoodID && element.businessObject.neighborhoodID !== this.treeNavigator.layerIsTriggered) {
        const overlay = this.overlays.get({element: element.id});
        OverlayUtils.setVisibleAllOverlays(overlay, false);
      }
    });

    this.eventBus.on('overlay.checked', (event) => {
      const element = event.element;
      if (element && element.businessObject.neighborhoodID === this.treeNavigator.layerIsTriggered) {
        const overlay = this.overlays.get({element: element.id});
        OverlayUtils.setVisibleAllOverlays(overlay, true);
      }
    });
  }


}

OverlaysInterceptor.$inject = [...CommandInterceptor.$inject, 'overlays', 'treeNavigator'];
